import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from '@environments/environment.dev';
import { StateService } from 'src/app/common/utils/store/state.service';
import { IAuthResponse } from '@modules/auth/interfaces/auth.interface';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private readonly stateService: StateService = inject(StateService);
  private readonly NAME_IN_STORE = 'session';
  private readonly NAME_IN_STORE_TIME_TO_REFRESH_TOKEN = 'refreshingToken';

  private isRefreshingToken: boolean = this.stateService.get(this.NAME_IN_STORE_TIME_TO_REFRESH_TOKEN) ?? false;
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly apiRefreshToken = `${environment.services.api}/auth/refresh-token`;
  private readonly session$: WritableSignal<string | boolean | null> = signal(this.stateService.value.session || null);

  constructor() {}

  get value() {
    return this.session$();
  }

  close(){
    this.session$.set(null);
    this.stateService.clear();
  }

  create(value: string | boolean) {
    this.session$.set(value);
    this.stateService.save({name: this.NAME_IN_STORE, value});

    if(this.isRefreshingToken){
      this.setStateForRefreshingToken(false);
    }
  }

  refreshToken(){
    if(this.isRefreshingToken){
      return;
    }
    
    this.setStateForRefreshingToken(true);

    this.httpClient.get<IAuthResponse>(this.apiRefreshToken)
    .subscribe({
      next: (response: IAuthResponse) => {
        this.create(response.jwt);
        console.log("Token refreshed!!!");
      },
      error: (error) => {
        this.close();
      }
    })
  }

  private setStateForRefreshingToken(value: boolean) {
    if(value){
      this.stateService.save({name: this.NAME_IN_STORE_TIME_TO_REFRESH_TOKEN, value});
      console.log("Refreshing...")
    }else{
      this.stateService.delete(this.NAME_IN_STORE_TIME_TO_REFRESH_TOKEN);
      console.log("Not refreshing...")
    }
    
    this.isRefreshingToken = value;
    
  }
}
